var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"txt-center"},[_vm._v("페이지를 불러오는 중입니다...")]),_c('waitModal',{attrs:{"isShow":_vm.wait.isWaitModalShow,"pWait":_vm.wait,"pTime":_vm.time,"pTotalCount":_vm.durationCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }